import { Directive, Input } from '@angular/core';

import { NavService } from '../../core/nav.service';
import { Course } from '../shared/course';

@Directive({
  selector: 'app-course-detail-nav' // tslint:disable-line:directive-selector
})
export class CourseDetailNavDirective {
  constructor(private nav: NavService) { }

  @Input() set course(course: Course) {
    if (course) {
      this.nav.title = course.name;
      this.nav.slackUrl = course.slackUrl;
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-detail/course-detail-nav.directive.ts